import { FC } from 'react';

import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { IMoodboardGridProps } from '~modules/moodboard/ModuleMoodboard';

const MoodboardGrid5: FC<IMoodboardGridProps> = props => {
  const { data, parentType, parentContext, fieldName, siblingsLength, canMove, stable } = props;
  return (
    <div className="row px-0 flex-wrap">
      <div className="col col-12 col-xl-8 moodboard-margin-bottom">
        <DraggableModuleContainer
          parentIsStable={stable}
          index={0}
          entityId={data[0]}
          proportions="16:9"
          parentContext={parentContext}
          parentType={parentType}
          fieldName={fieldName}
          siblingsLength={siblingsLength}
          canMove={Boolean(canMove)}
          canDelete={false}
          editablePictureClassName={{
            'u-full-height': true,
            relative: false,
          }}
          containerClassName={{ 'u-full-height': true, relative: true }}
        />
      </div>
      <div className="col col-12 col-xl-4 moodboard-margin-bottom">
        <DraggableModuleContainer
          parentIsStable={stable}
          index={1}
          entityId={data[1]}
          proportions="3:4"
          parentContext={parentContext}
          parentType={parentType}
          fieldName={fieldName}
          siblingsLength={siblingsLength}
          canMove={Boolean(canMove)}
          canDelete={false}
          editablePictureClassName={{ 'u-full-height': true }}
          containerClassName={{ 'u-full-height': true, relative: true }}
        />
      </div>
      <div className="col col-12 col-xl-4 moodboard-margin-bottom">
        <DraggableModuleContainer
          parentIsStable={stable}
          index={2}
          entityId={data[2]}
          proportions="4:3"
          parentContext={parentContext}
          parentType={parentType}
          fieldName={fieldName}
          siblingsLength={siblingsLength}
          canMove={Boolean(canMove)}
          canDelete={false}
          editablePictureClassName={{ 'u-full-height': true }}
          containerClassName={{ 'u-full-height': true, relative: true }}
        />
      </div>
      <div className="col col-12 col-xl-4 moodboard-margin-bottom">
        <DraggableModuleContainer
          parentIsStable={stable}
          index={3}
          entityId={data[3]}
          proportions="4:3"
          parentContext={parentContext}
          parentType={parentType}
          fieldName={fieldName}
          siblingsLength={siblingsLength}
          canMove={Boolean(canMove)}
          canDelete={false}
          editablePictureClassName={{ 'u-full-height': true }}
          containerClassName={{ 'u-full-height': true, relative: true }}
        />
      </div>
      <div className="col col-12 col-xl-4 moodboard-margin-bottom">
        <DraggableModuleContainer
          parentIsStable={stable}
          index={4}
          entityId={data[4]}
          proportions="4:3"
          parentContext={parentContext}
          parentType={parentType}
          fieldName={fieldName}
          siblingsLength={siblingsLength}
          canMove={Boolean(canMove)}
          canDelete={false}
          editablePictureClassName={{ 'u-full-height': true }}
          containerClassName={{ 'u-full-height': true, relative: true }}
        />
      </div>
    </div>
  );
};

export default MoodboardGrid5;
